// TruePrecision3D — Theme JS v2

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initCartDrawer();
  initHeaderScroll();
  initAccordions();
  initProductGallery();
  initQuantity();
  initHeroEntrance();
  initScrollReveal();
  initSpotlight();
  initStickyATC();
  initBackToTop();
  initWishlist();
  initRecentlyViewed();
  initCartQtyUpdater();
  initPrCartGroups();
});

// --- Header scroll ---
function initHeaderScroll() {
  const header = document.getElementById('SiteHeader');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('tp-header--scrolled', window.scrollY > 60);
  }, { passive: true });
}

// --- Mobile Nav ---
function initMobileNav() {
  const menuBtn = document.getElementById('MenuToggle');
  const closeBtn = document.getElementById('NavClose');
  const nav = document.getElementById('MobileNav');
  const overlay = document.getElementById('NavOverlay');

  function open() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  menuBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
}

// --- Cart Drawer ---
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartOverlay');
  const cartBtn = document.getElementById('CartToggle');
  const closeBtn = document.getElementById('CartClose');

  function openCart() {
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartBtn?.addEventListener('click', openCart);
  closeBtn?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);

  // Product card quick-add buttons
  document.querySelectorAll('[data-atc]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      if (!form) return;
      const label = btn.innerHTML;
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!res.ok) throw new Error();
        await refreshCart();
        openCart();
        showToast('Added to cart ✓');
      } catch(err) { showToast('Could not add to cart'); }
      finally { btn.innerHTML = label; btn.disabled = false; }
    });
  });

  // Main product page form — AJAX intercept
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const addBtn = productForm.querySelector('[name="add"]');
      if (!addBtn || addBtn.disabled) return;
      const label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm) });
        if (!res.ok) {
          const err = await res.json();
          showToast(err.description || 'Could not add to cart');
          return;
        }
        await refreshCart();
        openCart();
        showToast('Added to cart ✓');
      } catch(err) { showToast('Could not add to cart'); }
      finally { addBtn.textContent = label; addBtn.disabled = false; }
    });
  }
}

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const countEl = document.getElementById('CartCount');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    const itemsEl = document.getElementById('CartItems');
    if (itemsEl) {
      if (cart.item_count === 0) {
        itemsEl.innerHTML = `<div class="tp-cart-empty"><p>Your cart is empty.</p><a href="/collections" class="tp-btn tp-btn--primary">Shop Now</a></div>`;
      } else {
        const _kids = {};
        cart.items.forEach(it => {
          const pk = it.parent_relationship && it.parent_relationship.parent_key;
          if (pk) (_kids[pk] = _kids[pk] || []).push(it);
        });
        itemsEl.innerHTML = cart.items.map((item, idx) => {
          if (item.parent_relationship) return '';
          if (item.properties && item.properties['Configuration ID']) return _prCartCardHTML(item, _kids[item.key] || []);
          return `
          <div class="tp-cart-item">
            <div class="tp-cart-item__image">${item.image ? `<img src="${item.image}" alt="${_esc(item.title)}" width="72" height="72" loading="lazy">` : ''}</div>
            <div class="tp-cart-item__info">
              <div class="tp-cart-item__name">${_esc(item.product_title)}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="tp-cart-item__variant">${_esc(item.variant_title)}</div>` : ''}
              <div class="tp-cart-item__price">£${(item.final_line_price / 100).toFixed(2)}</div>
              <div class="tp-cart-qty" data-line="${idx + 1}" data-variant="${item.variant_id}">
                <button type="button" class="tp-cart-qty__btn" data-action="decrease">−</button>
                <span class="tp-cart-qty__count">${item.quantity}</span>
                <button type="button" class="tp-cart-qty__btn" data-action="increase">+</button>
              </div>
            </div>
          </div>`;
        }).join('');
      }
    }

    let footerEl = document.querySelector('.tp-cart-drawer__footer');
    if (cart.item_count > 0) {
      const subtotal = '£' + (cart.total_price / 100).toFixed(2);
      if (!footerEl) {
        footerEl = document.createElement('div');
        footerEl.className = 'tp-cart-drawer__footer';
        document.getElementById('CartDrawer').appendChild(footerEl);
      }
      footerEl.innerHTML = `
        <div class="tp-cart-drawer__total"><span>Subtotal</span><span class="tp-cart-drawer__total-price">${subtotal}</span></div>
        <a href="/cart" class="tp-btn tp-btn--outline tp-btn--full" style="margin-bottom:10px;">View Cart</a>
        <a href="/checkout" class="tp-btn tp-btn--primary tp-btn--full">Checkout</a>
        <p style="font-size:11px;color:rgba(255,255,255,0.3);text-align:center;margin-top:10px;">Taxes and shipping calculated at checkout</p>`;
    } else if (footerEl) {
      footerEl.remove();
    }

    // Update free shipping bar
    const FREE_THRESHOLD = 3000;
    const barText = document.querySelector('.tp-cart-shipping-bar__text');
    const barFill = document.getElementById('CartShippingFill');
    if (barText && barFill) {
      const pct = Math.min(100, Math.round(cart.total_price * 100 / FREE_THRESHOLD));
      barFill.style.width = pct + '%';
      const remaining = FREE_THRESHOLD - cart.total_price;
      if (remaining > 0) {
        barText.innerHTML = `Spend <strong>£${(remaining / 100).toFixed(2)}</strong> more for free UK delivery`;
      } else {
        barText.innerHTML = `<span style="color:var(--color-gold);">✓ You've unlocked free UK delivery!</span>`;
      }
    }

    // Load cart upsell
    if (cart.item_count > 0 && cart.items[0]) {
      loadCartUpsell(cart.items[0].product_id);
    } else {
      const upsellEl = document.getElementById('CartUpsell');
      if (upsellEl) upsellEl.style.display = 'none';
    }

  } catch(e) {}
}

// --- Precision Rack — grouped cart card helpers ---
function _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

function _prCartCardHTML(p, kids) {
  const m = c => '£' + ((c || 0) / 100).toFixed(2);
  let fin = p.final_line_price, orig = p.original_line_price;
  (kids || []).forEach(k => { fin += k.final_line_price; orig += k.original_line_price; });
  const props = p.properties || {};
  const spec = Object.keys(props)
    .filter(k => k && props[k] && k.charAt(0) !== '_' && k !== 'Configuration ID')
    .map(k => `<li><span class="tp-pr-cart__spec-k">${_esc(k)}</span> <span class="tp-pr-cart__spec-v">${_esc(props[k])}</span></li>`).join('');
  const cfgId = props['Configuration ID'] ? `<div class="tp-pr-cart__cfgid" title="Configuration reference">${_esc(props['Configuration ID'])}</div>` : '';
  const state = props['_config_state'];
  const change = state ? `<a class="tp-pr-cart__link" href="/products/precision-rack?${_esc(state)}">Change design</a>` : '';
  const img = p.image
    ? `<img src="${p.image}" alt="${_esc(p.product_title || 'Precision Rack')}" width="80" height="80" loading="lazy">`
    : `<span class="tp-pr-cart__ph" aria-hidden="true"><svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M24 7 42 40H6L24 7Z"/><path d="M17 30h14"/></svg></span>`;
  const was = orig > fin ? ` <s class="tp-pr-cart__was">${m(orig)}</s>` : '';
  return `
    <div class="tp-cart-item tp-cart-item--pr" data-pr-group data-line-key="${p.key}">
      <div class="tp-cart-item__image">${img}</div>
      <div class="tp-cart-item__info">
        <div class="tp-cart-item__name">${_esc(p.product_title || 'Precision Rack')}</div>
        <ul class="tp-pr-cart__spec">${spec}</ul>
        ${cfgId}
        <div class="tp-cart-item__price">${m(fin)}${was}</div>
        <div class="tp-pr-cart__actions">
          <div class="tp-cart-qty" data-pr-qty data-line-key="${p.key}">
            <button type="button" class="tp-cart-qty__btn" data-action="decrease" aria-label="Decrease quantity">−</button>
            <span class="tp-cart-qty__count">${p.quantity}</span>
            <button type="button" class="tp-cart-qty__btn" data-action="increase" aria-label="Increase quantity">+</button>
          </div>
          ${change}
          <button type="button" class="tp-pr-cart__link tp-pr-cart__remove" data-pr-remove data-line-key="${p.key}">Remove</button>
        </div>
      </div>
    </div>`;
}

function initPrCartGroups() {
  const onCartPage = () => !!document.getElementById('CartPageItems');
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-pr-remove]');
    const qtyBtn = e.target.closest('[data-pr-qty] .tp-cart-qty__btn');

    if (remove) {
      e.preventDefault();
      remove.disabled = true;
      try {
        await change(remove.dataset.lineKey, 0); // Shopify auto-removes the nested upgrade lines
        if (onCartPage()) { window.location.reload(); return; }
        await refreshCart();
        window.showToast && window.showToast('Removed from cart');
      } catch (err) { remove.disabled = false; }
      return;
    }

    if (qtyBtn) {
      e.preventDefault();
      const wrap = qtyBtn.closest('[data-pr-qty]');
      const key = wrap.dataset.lineKey;
      const countEl = wrap.querySelector('.tp-cart-qty__count');
      const cur = parseInt(countEl.textContent, 10) || 1;
      const next = Math.max(0, qtyBtn.dataset.action === 'increase' ? cur + 1 : cur - 1);
      wrap.querySelectorAll('.tp-cart-qty__btn').forEach(b => b.disabled = true);
      try {
        const cart = await (await fetch('/cart.js')).json();
        const kids = cart.items.filter(it => it.parent_relationship && it.parent_relationship.parent_key === key);
        await change(key, next);
        for (let i = 0; i < kids.length; i++) { await change(kids[i].key, next); }
        if (onCartPage()) { window.location.reload(); return; }
        await refreshCart();
      } catch (err) {
        wrap.querySelectorAll('.tp-cart-qty__btn').forEach(b => b.disabled = false);
      }
      return;
    }
  });
}

// --- Toast notification ---
function showToast(msg) {
  let el = document.getElementById('TPToast');
  if (!el) {
    el = document.createElement('div');
    el.id = 'TPToast';
    el.className = 'tp-toast';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('is-visible');
  setTimeout(() => el.classList.remove('is-visible'), 3000);
}
window.showToast = showToast;

// --- Accordions ---
function initAccordions() {
  document.querySelectorAll('.tp-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.tp-accordion__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.tp-accordion__item.is-open').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });
}

// --- Product gallery ---
function initProductGallery() {
  const thumbs = document.querySelectorAll('.tp-product__thumb');
  const mainWrap = document.getElementById('ProductMainMedia');
  if (!thumbs.length || !mainWrap) return;

  function fadeIn(el) {
    el.style.opacity = '0';
    el.style.transform = 'scale(0.97)';
    el.style.transition = 'opacity 0.22s ease, transform 0.22s ease';
    requestAnimationFrame(() => { el.style.opacity = '1'; el.style.transform = ''; });
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      const type = thumb.dataset.mediaType;

      if (type === 'video') {
        const sources = JSON.parse(thumb.dataset.mediaSources || '[]');
        const video = document.createElement('video');
        video.className = 'tp-product__video';
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = true;
        sources.forEach(s => {
          const src = document.createElement('source');
          src.src = s.url;
          src.type = s.type;
          video.appendChild(src);
        });
        mainWrap.innerHTML = '';
        mainWrap.appendChild(video);
        fadeIn(video);

      } else if (type === 'external_video') {
        const iframe = document.createElement('iframe');
        iframe.className = 'tp-product__video-frame';
        iframe.src = thumb.dataset.mediaUrl;
        iframe.frameBorder = '0';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        mainWrap.innerHTML = '';
        mainWrap.appendChild(iframe);
        fadeIn(iframe);

      } else {
        const src = thumb.dataset.src;
        if (!src) return;
        let img = mainWrap.querySelector('#ProductMainImage');
        if (!img) {
          img = document.createElement('img');
          img.id = 'ProductMainImage';
          img.width = 900;
          mainWrap.innerHTML = '';
          mainWrap.appendChild(img);
        }
        img.style.opacity = '0';
        img.style.transform = 'scale(0.97)';
        img.style.transition = 'opacity 0.22s ease, transform 0.22s ease';
        img.src = src;
        img.onload = () => { img.style.opacity = '1'; img.style.transform = ''; };
      }
    });
  });
}

// --- Quantity stepper ---
function initQuantity() {
  document.querySelectorAll('.tp-quantity').forEach(el => {
    const input = el.querySelector('.tp-quantity__input');
    if (!input) return;
    el.querySelector('.tp-quantity__btn--minus')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    el.querySelector('.tp-quantity__btn--plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });
}

// --- Hero entrance animation ---
function initHeroEntrance() {
  const hero = document.querySelector('.tp-hero');
  if (!hero) return;
  hero.classList.add('tp-hero--loaded');
}

// --- Scroll reveal ---
function initScrollReveal() {
  // Staggered grids
  document.querySelectorAll('.tp-product-grid, .tp-product-grid--4').forEach(grid => {
    grid.querySelectorAll('.tp-product-card').forEach((el, i) => {
      el.classList.add('tp-reveal');
      el.style.transitionDelay = `${(i % 4) * 90}ms`;
    });
  });

  // Trust bar items
  document.querySelectorAll('.tp-trust-item').forEach((el, i) => {
    el.classList.add('tp-reveal');
    el.style.transitionDelay = `${i * 70}ms`;
  });

  // Section headers
  document.querySelectorAll('.tp-section-header, .tp-section-header--center').forEach(el => {
    el.classList.add('tp-reveal');
  });

  // Reviews
  document.querySelectorAll('.tp-review-card').forEach((el, i) => {
    el.classList.add('tp-reveal');
    el.style.transitionDelay = `${(i % 3) * 100}ms`;
  });

  // Engineering stats
  document.querySelectorAll('.tp-engineering__stat, .tp-stat').forEach((el, i) => {
    el.classList.add('tp-reveal');
    el.style.transitionDelay = `${i * 80}ms`;
  });

  // Creator cards
  document.querySelectorAll('.tp-creator-card, .tp-creator').forEach((el, i) => {
    el.classList.add('tp-reveal');
    el.style.transitionDelay = `${i * 80}ms`;
  });

  // Collection cards
  document.querySelectorAll('.tp-collection-card').forEach((el, i) => {
    el.classList.add('tp-reveal');
    el.style.transitionDelay = `${(i % 3) * 80}ms`;
  });

  // CTA, wholesale, email blocks
  document.querySelectorAll('.tp-customisation-cta, .tp-wholesale-teaser, .tp-email-capture, .tp-cta-block').forEach(el => {
    el.classList.add('tp-reveal');
  });

  // Spotlight sides (left/right entry)
  document.querySelectorAll('.tp-reveal--left, .tp-reveal--right').forEach(el => {
    el.classList.add('tp-reveal');
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('tp-reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.tp-reveal').forEach(el => observer.observe(el));
}

// --- Product Spotlight ---
function initSpotlight() {
  const section = document.getElementById('SpotlightSection');
  if (!section) return;

  const swatches   = section.querySelectorAll('.tp-spotlight__swatch');
  const img        = document.getElementById('SpotlightImage');
  const priceEl    = document.getElementById('SpotlightPrice');
  const compareEl  = document.getElementById('SpotlightCompare');
  const colourEl   = document.getElementById('SpotlightColour');
  const variantIn  = document.getElementById('SpotlightVariantId');
  const addBtn     = document.getElementById('SpotlightAddBtn');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatches.forEach(s => { s.classList.remove('active'); s.setAttribute('aria-pressed','false'); });
      swatch.classList.add('active');
      swatch.setAttribute('aria-pressed','true');

      const price   = parseInt(swatch.dataset.price   || '0');
      const compare = parseInt(swatch.dataset.compare || '0');
      const imgSrc  = swatch.dataset.image;

      if (variantIn) variantIn.value = swatch.dataset.variantId;
      if (colourEl)  colourEl.textContent = swatch.dataset.colour;

      if (priceEl)   priceEl.textContent = '£' + (price / 100).toFixed(2);
      if (compareEl) {
        if (compare > price) {
          compareEl.textContent = '£' + (compare / 100).toFixed(2);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Gallery stays the same regardless of colour — no per-variant images
    });
  });

  // Spotlight add to cart
  const form = document.getElementById('SpotlightForm');
  if (form && addBtn) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const label = addBtn.innerHTML;
      addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Adding…';
      addBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!res.ok) throw new Error();
        await refreshCart();
        if (typeof openCart === 'function') openCart();
        window.showToast && window.showToast('Added to cart ✓');
      } catch { window.showToast && window.showToast('Could not add to cart'); }
      finally { addBtn.innerHTML = label; addBtn.disabled = false; }
    });
  }
}

// --- Sticky ATC bar ---
function initStickyATC() {
  const bar = document.getElementById('StickyATC');
  const mainBtn = document.getElementById('MainAddToCart');
  if (!bar || !mainBtn) return;
  const observer = new IntersectionObserver(([entry]) => {
    bar.classList.toggle('is-visible', !entry.isIntersecting);
    bar.setAttribute('aria-hidden', String(entry.isIntersecting));
  }, { threshold: 0 });
  observer.observe(mainBtn);
}

// --- Back to top ---
function initBackToTop() {
  const btn = document.getElementById('BackToTop');
  if (!btn) return;
  window.addEventListener('scroll', () => {
    btn.classList.toggle('is-visible', window.scrollY > 400);
  }, { passive: true });
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
}

// --- Wishlist (localStorage) ---
function initWishlist() {
  const btn = document.getElementById('WishlistBtn');
  if (!btn) return;
  const productId = btn.dataset.productId;

  function getList() { try { return JSON.parse(localStorage.getItem('tp_wishlist') || '[]'); } catch { return []; } }
  function saveList(l) { localStorage.setItem('tp_wishlist', JSON.stringify(l)); }

  if (getList().includes(productId)) btn.classList.add('is-wishlisted');

  btn.addEventListener('click', () => {
    let list = getList();
    if (list.includes(productId)) {
      list = list.filter(id => id !== productId);
      btn.classList.remove('is-wishlisted');
      showToast('Removed from wishlist');
    } else {
      list.push(productId);
      btn.classList.add('is-wishlisted');
      showToast('Saved to wishlist ♥');
    }
    saveList(list);
  });
}

// --- Recently viewed (localStorage) ---
function initRecentlyViewed() {
  const meta = document.getElementById('ProductRecentlyViewedMeta');
  if (!meta) return;

  const current = {
    id: meta.dataset.id,
    title: meta.dataset.title,
    price: meta.dataset.price,
    image: meta.dataset.image,
    url: meta.dataset.url
  };

  let viewed = [];
  try { viewed = JSON.parse(localStorage.getItem('tp_recently_viewed') || '[]'); } catch {}
  viewed = viewed.filter(p => p.id !== current.id);
  viewed.unshift(current);
  if (viewed.length > 6) viewed = viewed.slice(0, 6);
  localStorage.setItem('tp_recently_viewed', JSON.stringify(viewed));

  const container = document.getElementById('RecentlyViewedGrid');
  const section = document.getElementById('RecentlyViewedSection');
  if (!container || !section) return;

  const others = viewed.filter(p => p.id !== current.id).slice(0, 4);
  if (!others.length) return;

  section.style.display = '';
  container.innerHTML = others.map(p => `
    <a href="${p.url}" class="tp-rv-card">
      <div class="tp-rv-card__img">
        ${p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy" width="300" height="300">` : '<div class="tp-rv-card__no-img"></div>'}
      </div>
      <div class="tp-rv-card__body">
        <div class="tp-rv-card__title">${p.title}</div>
        <div class="tp-rv-card__price">${p.price}</div>
      </div>
    </a>
  `).join('');
}

// --- Cart quantity updater ---
function initCartQtyUpdater() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.tp-cart-qty__btn');
    if (!btn) return;
    if (btn.closest('[data-pr-qty]')) return; // Precision Rack groups handled by initPrCartGroups()
    const wrapper = btn.closest('.tp-cart-qty');
    if (!wrapper) return;
    const line = parseInt(wrapper.dataset.line, 10);
    const countEl = wrapper.querySelector('.tp-cart-qty__count');
    const currentQty = parseInt(countEl.textContent, 10);
    const newQty = btn.dataset.action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
    btn.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: newQty })
      });
      await refreshCart();
    } catch {}
    btn.disabled = false;
  });
}

// --- Cart upsell (recommendations) ---
async function loadCartUpsell(productId) {
  const el = document.getElementById('CartUpsell');
  if (!el || !productId) return;
  try {
    const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=1&intent=cart`);
    const data = await res.json();
    const p = data.products && data.products[0];
    if (!p) { el.style.display = 'none'; return; }
    const img = p.featured_image ? `<img src="${p.featured_image.src}" alt="${p.title}" width="56" height="56" loading="lazy" style="object-fit:cover;border-radius:var(--radius);">` : '';
    const price = '£' + (p.price / 100).toFixed(2);
    el.style.display = 'block';
    el.innerHTML = `
      <p class="tp-cart-upsell__label">You might also like</p>
      <div class="tp-cart-upsell__row">
        <div class="tp-cart-upsell__img">${img}</div>
        <div class="tp-cart-upsell__info">
          <div class="tp-cart-upsell__title">${p.title}</div>
          <div class="tp-cart-upsell__price">${price}</div>
        </div>
        <button class="tp-btn tp-btn--outline tp-cart-upsell__add" data-variant="${p.variants[0].id}" style="white-space:nowrap;padding:8px 14px;font-size:12px;">Add</button>
      </div>`;
    el.querySelector('.tp-cart-upsell__add').addEventListener('click', async function() {
      this.textContent = '✓';
      this.disabled = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
      });
      await refreshCart();
    });
  } catch { el.style.display = 'none'; }
}

// --- Variant selection on product page ---
document.querySelectorAll('.tp-variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const pos = btn.dataset.optionPosition;
    document.querySelectorAll(`[data-option-position="${pos}"]`).forEach(b => {
      b.classList.remove('active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-pressed', 'true');
    const label = document.getElementById(`OptionLabel-${pos}`);
    if (label) label.textContent = btn.dataset.optionValue;

    // Gallery stays the same regardless of colour — no per-variant images
  });
});
